import { render } from "./BlogHowBrushProperly.vue?vue&type=template&id=2977f153"
import script from "./BlogHowBrushProperly.vue?vue&type=script&lang=js"
export * from "./BlogHowBrushProperly.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__